import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { UserDetail } from "../../../services/storage.service";

const state = {
  profileList: [],
  athleteId: UserDetail.getUserID(),
  profileId: "",
  editProfileData: {},
  viewProfileData: {},
  loading: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
